import { render, staticRenderFns } from "./transaction-details.vue?vue&type=template&id=1697d624&"
import script from "./transaction-details.vue?vue&type=script&lang=js&"
export * from "./transaction-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports